var alignment_rtlignore_default = {
  "alignLeft": "Ercjo",
  "textWrapNowrap": "-YDSa",
  "alignRight": "_7CSk4",
  "alignCenter": "hjPGD",
  "sizeFullWidth": "Hdr2o",
  "renderedInTable": "Oojlc",
  "sizeOriginal": "V2Ll-",
  "sizeContent": "kOJY8",
  "sizeSmall": "IpOfq",
  "sizeSmallCenter": "o9y6k",
  "flex": "Ga5BY",
  "LEFT": "_357Qv",
  "CENTER": "dO6oc",
  "RIGHT": "MOPJu",
  "AUTO": "_178TK",
  "JUSTIFY": "MC1UA"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
